var React = require('react');

function Clutch (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0)"},[React.createElement("path",{"d":"M163.653,27.082a6.831,6.831,0,0,1-4.616,1.711,6.592,6.592,0,0,1-6.784-6.817,6.444,6.444,0,0,1,6.784-6.7,7,7,0,0,1,4.647,1.682l.853.734,3.792-3.791-.949-.856A12.41,12.41,0,0,0,159.035,9.9,11.7,11.7,0,0,0,146.9,21.947a11.912,11.912,0,0,0,12.136,12.2,12.278,12.278,0,0,0,8.407-3.178l.917-.856-3.851-3.788Z","transform":"translate(-146.899 -9.904)","key":0}),React.createElement("path",{"d":"M156.573,15.642a4.066,4.066,0,1,1-4.065,4.066,4.065,4.065,0,0,1,4.065-4.066","transform":"translate(-144.621 -7.574)","key":1})]));
}

Clutch.defaultProps = {"width":"21.46","height":"24.238","viewBox":"0 0 21.46 24.238"};

module.exports = Clutch;

Clutch.default = Clutch;
